import PropTypes from 'prop-types';
import React, { useState } from "react";

// Reactstrap Components
import {
  Alert,
  Collapse,
  Nav,
  Navbar,
  NavbarToggler,
  NavItem,
} from "reactstrap";

// React Router
// import { Link, NavLink as RouterNavLink } from "react-router-dom";

// Redux
import { connect } from "react-redux";
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";

// i18n
import { withTranslation } from "react-i18next";

// Logos
// import secLogo from "../../assets/images/Logo.svg";
// import secLogo from "../../assets/images/TrueFocus Automation Logo v.web soft white.png";
import secLogo from "../../assets/images/appraisal_hunter_logo_white.png";
// popover button
import PopoverButton from ".././../pages/Dboard/PopoverButton";
// <-- NEW: Import the hook for checking unsaved changes
import { useUnsavedChanges } from '../../context/UnsavedChangesContext'; 
import SafeLink from 'pages/Ui/SafeLink/SafeLink';

const Header = props => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  // <-- NEW: Get the isBlocked state from our global context
  const { isBlocked } = useUnsavedChanges();

  const user = JSON.parse(localStorage.getItem("userData"));
  const isTrue = user ? true : false;
  // console.log("user role",user.user.role)
  const userName = user.user.first_name;

  // <-- NEW: Modified handleLogout function
  const handleLogout = () => {
    // Check for unsaved changes before doing anything else
    if (isBlocked) {
      if (!window.confirm('You have unsaved changes. Are you sure you want to log out?')) {
        return; // Stop the logout process if the user clicks "Cancel"
      }
    }
    // If not blocked, or if user confirmed, proceed with logout
    localStorage.clear();
    window.location.href = "/";
  };


  return (
     <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              {/* <-- NEW: Use SafeLink instead of Link */}
              <SafeLink to="/dashboard" className="logo logo-dark">
                <span className="logo-sm">
                  <img className="img-fluid" src={secLogo} alt="" />
                </span>
                <span className="logo-lg">
                  <img className="img-fluid" src={secLogo} alt="" />
                </span>
              </SafeLink>
              {/* <-- NEW: Use SafeLink instead of Link */}
              <SafeLink to="/dashboard" className="logo logo-light">
                <span className="logo-sm">
                  <img className='img-fluid' src={secLogo} alt="" />
                </span>
                <span className="logo-lg">
                  <img className='img-fluid' src={secLogo} alt="" />
                </span>
              </SafeLink>
            </div>
          </div>
          <div className="d-flex">
              
          </div>
          <div className="d-flex">
            <Navbar color="transparent" dark expand="md">
              <NavbarToggler onClick={toggle} />
              <Collapse isOpen={isOpen} navbar>
                <Nav className="ms-auto align-items-center gap-3" navbar>
                  
                  <NavItem className='nav-link'>
                    User: {userName}
                  </NavItem>
                  
                  <NavItem>
                    {/* <-- NEW: Use SafeLink instead of RouterNavLink */}
                    <SafeLink to="/dashboard" className="nav-link" invalidate={["orderList", "compList"]}>
                      Dashboard
                    </SafeLink>
                  </NavItem>
                  
                  {user?.user?.role !== "00000000-0000-0000-0000-000000000001"  && (<NavItem>
                        <PopoverButton title={'Create Orders'}/>
                  </NavItem>)}
                  
                  {user?.user?.role === "00000000-0000-0000-0000-000000000002"  && (<NavItem>
                        <SafeLink to="/userlist" className="nav-link" invalidate={["userList"]}>
                          Users
                        </SafeLink>
                  </NavItem>)}
                  
                  <NavItem style={{color:"#ffffff"}}>
                    <SafeLink to="/user-credit-dashboard" className='nav-link'>Settings</SafeLink>
                  </NavItem>

                  <NavItem>
                    {/* <-- NEW: Use SafeLink instead of RouterNavLink */}
                    <SafeLink to="/faq" className="nav-link">
                      FAQs
                    </SafeLink>
                  </NavItem>

                  {isTrue && (
                    <NavItem>
                      <button onClick={handleLogout} className='btn btn-light'>
                        <i className="fa fa-sign-out-alt me-1"></i>
                        <span>Logout</span>
                      </button>
                    </NavItem>
                  )}
                </Nav>
              </Collapse>
            </Navbar>
          </div>

        </div>
      </header>
    </React.Fragment>
  );
};

// PropTypes and Redux connection remain the same
Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func
};

const mapStatetoProps = state => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
  } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));